import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useMemo } from "react";
import { useRefsContext } from "@/contexts/ref";
import { useUnits } from "@/contexts/classified";
import { Section } from "@/components/UI";
import { Header } from "./components/Header";
import { Unit } from "./components/Unit";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { ChevronDownIcon } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
export const testId = "cdp-sections-units";
export const NewbuildUnits = () => {
    const { t } = useI18n();
    const { unitsSectionRef } = useRefsContext();
    const { units } = useUnits() || {};
    const [showMoreUnits, setShowMoreUnits] = useState(false);
    const onPressShowMoreUnits = useCallback(() => {
        setShowMoreUnits(true);
    }, []);
    const displayShowMoreButton = useMemo(() => !showMoreUnits && (units === null || units === void 0 ? void 0 : units.length) > 5, [showMoreUnits, units === null || units === void 0 ? void 0 : units.length]);
    if (!(units === null || units === void 0 ? void 0 : units.length))
        return null;
    return (_jsxs(Section, { ref: unitsSectionRef, testId: testId, unsafeClassname: "HideOnPrint", children: [_jsx(Header, {}), _jsx(Box, { as: "ul", listStyleType: "none", padding: 0, margin: 0, children: units.slice(0, showMoreUnits ? undefined : 5).map((unit, idx) => (_jsx(Unit, { unit: unit, isLast: (displayShowMoreButton && idx === 4) || idx === units.length - 1 }, unit.id || `unit-${idx}`))) }), displayShowMoreButton && (_jsx(Button, { variant: "secondary", onPress: onPressShowMoreUnits, marginTop: "spacing.32", icon: ChevronDownIcon, testId: `${testId}-show-more`, children: t("pdpSeeker_unitTable_showMoreUnitsButtonTitle") }))] }));
};
